import { Button, createStyles, Grid, Link, makeStyles, Theme } from "@material-ui/core"
import { OpenInNew } from "@material-ui/icons"
import { FormWithRedirect, required, TextInput, useTranslate } from "react-admin"

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        fixed_fee: {},
        amount: { fontWeight: 'bold' },
        root: {
            flexGrow: 1,
        },
    })
)

const MerchantDocs = (props: any) => {
    const classes = useStyles()
    const translate = useTranslate()

    return <FormWithRedirect
        {...props}
        render={formProps => {
            // console.log(formProps.record)
            return (
                <Grid container className={classes.root} spacing={2}>
                    <Grid item xs={12} sm={12} lg={12}>
                        <Link
                            target="_blank"
                            color="inherit"
                            href={formProps?.record?.url}
                        >
                            <Button
                                endIcon={<OpenInNew />}
                                color="primary"
                            // variant="contained"
                            >
                                {translate('resources.merchants.links.docLink')}
                            </Button>
                        </Link>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12}>
                        <TextInput
                            source="name"
                            fullWidth
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                        <TextInput
                            source="type"
                            fullWidth
                            // validate={[required()]}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                        <TextInput
                            source="status"
                            fullWidth
                            validate={[required()]}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                </Grid>
            )
        }}
    />
}

export default MerchantDocs